module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title "
  }, [_vm._v("My Files")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-narrow "
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadedfiles), function(file) {
    return _c('tr', {
      attrs: {
        "id": file.randname
      }
    }, [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(file.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(file.created_on))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-danger is-outlined",
      style: ('font-size:.8rem;'),
      on: {
        "click": function($event) {
          _vm.deleteFile(file.randname)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-trash"
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-danger is-outlined",
      style: ('font-size:.8rem;'),
      on: {
        "click": function($event) {
          _vm.navigateTo('/edit/' + file.randname)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-pencil"
    })])])])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Uploaded On")]), _vm._v(" "), _c('th', [_vm._v("Download Link")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-434b4cc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/admin/MyFiles.vue
// module id = 154
// module chunks = 34